import {ResultSubject, Span} from '../../../../styled';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';
import React from 'react';

const Title = ({ sender }: any) => {

  return (
    <ResultSubject>
      <Span>From: </Span>
      {sender ? <HighlightMarker>{sender}</HighlightMarker> : 'No sender information'}
    </ResultSubject>
  )
};

export default Title;